import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, delay, catchError } from 'rxjs';
import { PensionContributionsResponse } from './pension-contribution-employee.model';
import { environment } from '@env/environment';

@Injectable()
export class PensionContributionsDataProvider {
  protected apiRoot = `${environment.apiPaths.pensions}`;

  constructor(private http: HttpClient) {}

  getSubmissionContributions$(submissionId: number): Observable<PensionContributionsResponse> {
    //TODO: Remove this once the API is implemented and use the real API
    return of(this.getMockContributionsData(submissionId)).pipe(delay(500));
  }

  getSubmissionPaymentErrors$(submissionId: number): Observable<any[]> {
    //TODO: Remove this once the API is implemented and use the real API
    return this.http.get<any[]>(`${this.apiRoot}/submission/${submissionId}/payment-errors-fake-data`).pipe(
      catchError(() => {
        return of([]);
      })
    );
  }

  getSubmissionSubmissionsErrors$(submissionId: number): Observable<any[]> {
    //TODO: Remove this once the API is implemented and use the real API
    return this.http.get<any[]>(`${this.apiRoot}/submission/${submissionId}/submissions-errors-fake-data`).pipe(
      catchError(() => {
        return of([]);
      })
    );
  }

  private getMockContributionsData(submissionId: number): PensionContributionsResponse {
    return {
      submissionId,
      payrollName: 'Main Payroll',
      providerName: 'Aviva',
      periodStart: '2025-10-01',
      periodEnd: '2025-10-31',
      contributions: [
        {
          employeeId: 'EMP001',
          employeeName: 'John Smith',
          errorDescription: undefined,
          periodEarnings: 2500.0,
          employeeContribution: 125.0,
          employerContribution: 75.0,
          total: 200.0,
          pensionGroup: 'Group A',
          zeroContributionsReason: undefined
        },
        {
          employeeId: 'EMP002',
          employeeName: 'Jane Doe',
          errorDescription: undefined,
          periodEarnings: 3200.0,
          employeeContribution: 160.0,
          employerContribution: 96.0,
          total: 256.0,
          pensionGroup: 'Group A',
          zeroContributionsReason: undefined
        },
        {
          employeeId: 'EMP003',
          employeeName: 'Bob Johnson',
          errorDescription: undefined,
          periodEarnings: 2800.0,
          employeeContribution: 140.0,
          employerContribution: 84.0,
          total: 224.0,
          pensionGroup: 'Group B',
          zeroContributionsReason: undefined
        },
        {
          employeeId: 'EMP004',
          employeeName: 'Alice Williams',
          errorDescription: 'Below earnings threshold',
          periodEarnings: 500.0,
          employeeContribution: 0.0,
          employerContribution: 0.0,
          total: 0.0,
          pensionGroup: 'Group A',
          zeroContributionsReason: 'Below auto-enrolment threshold'
        },
        {
          employeeId: 'EMP005',
          employeeName: 'Charlie Brown',
          errorDescription: undefined,
          periodEarnings: 4500.0,
          employeeContribution: 225.0,
          employerContribution: 135.0,
          total: 360.0,
          pensionGroup: 'Group A',
          zeroContributionsReason: undefined
        }
      ]
    };
  }

  // private getMockPaymentErrorsData(submissionId: number): any[] {
  //   return [
  //     {
  //       errorId: 'ERR-001',
  //       errorDescription: 'Payment rejected - Invalid bank account details for employee John Smith'
  //     },
  //     {
  //       errorId: 'ERR-002',
  //       errorDescription: 'Payment failed - Insufficient funds in employer pension account'
  //     },
  //     {
  //       errorId: 'ERR-003',
  //       errorDescription: 'Member not found - Employee ID EMP006 does not exist with pension provider'
  //     },
  //     {
  //       errorId: 'ERR-004',
  //       errorDescription: 'Contribution amount exceeds annual allowance limit for employee Jane Doe'
  //     },
  //     {
  //       errorId: 'ERR-005',
  //       errorDescription: 'Payment processing timeout - Transaction ID TXN-98765 failed to complete'
  //     }
  //   ];
  // }

  // private getMockSubmissionsErrorsData(submissionId: number): any[] {
  //   return [
  //     {
  //       errorId: 'ERR-001',
  //       errorDescription: 'Submission rejected - Invalid bank account details for employee John Smith'
  //     }
  //   ];
  // }
}
